import "core-js/stable";
import { handleImgErrors } from "./modules/handleImgErrors";
import { getApiToken } from "./modules/tokenUtils";
import { formatFutureRelative } from "./modules/time-utils";
import * as Sentry from "@sentry/browser";
// import api from "@public/js/api";

// Initialize Sentry
Sentry.init({
  dsn: "https://40e19bafa75d417ead2733a00ab3e30f@sentry.interpals.net/8",
  ignoreErrors: [
    "Non-Error exception captured",
    "Non-Error promise rejection captured"
  ]
});

Sentry.setTag("user_id", window.userId ?? "none");

Sentry.setContext("user", {
  id: window.userId ?? "none"
});

handleImgErrors();

// Fetch api token on page load if not present in local storage
// document.addEventListener("DOMContentLoaded", async () => {
window.getApiToken = getApiToken;
window.formatFutureRelative = formatFutureRelative;
//   api.init(token);

  // Make api object available globally (for jquery)
  // window.api = api.methods;
// });

console.log("v:6");
